"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PluginBase_1 = require("../PluginBase");
/**
 * Error handler base plugin implementation.
 *
 * Serves as a global widget error handler for error that can happen in most
 * location.
 */
class ErrorHandlerPlugin extends PluginBase_1.default {
}
exports.default = ErrorHandlerPlugin;
